import FileList from '@/components/FileList';
import { Label } from '@/components/ui/label';
import { Attachment, UploadBatchStatus } from '@/graphql/graphql';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

interface iAttachmentListProps {
  attachments: Attachment[];
  batchStatus?: UploadBatchStatus;
}

const AttachmentList: FunctionComponent<iAttachmentListProps> = ({ attachments, batchStatus }) => {
  const { t } = useTranslation('project');
  return (
    <>
      <Label className='mt-8'>{t('batch.files')}</Label>
      <div className='mt-2 border border-slate-200/70 rounded-md px-2 py-2 bg-white dark:bg-stone-900 dark:border-stone-800'>
        {attachments?.length === 0 ? (
          <div className='text-center py-8 text-muted-foreground'>{t('batch.noAttachments')}</div>
        ) : (
          <>
            <FileList
              files={attachments.map((attachment) => ({
                id: attachment.id,
                name: attachment.filename,
                path: attachment.filename,
                size: attachment.contentLength ?? 0,
                type: attachment.contentType,
                downloadUrl: attachment.url || undefined,
                byproducts: attachment.byproducts?.map((bp) => ({
                  id: bp.id,
                  filename: bp.filename,
                  type: bp.type,
                  contentLength: bp.contentLength,
                  downloadUrl: bp.downloadUrl,
                })),
                file: new File([], attachment.filename),
                isDirectory: false,
              }))}
            />
          </>
        )}
      </div>
    </>
  );
};

export default AttachmentList;
